/**
 * Setores e Quadro — Hub unificado (Sprint A · Item 1).
 *
 * Consolida em uma única rota (`/setores-e-quadro`) as telas antes dispersas:
 *   - Setores (CRUD + dashboard)
 *   - Quadros de Trabalho (por escala/turno)
 *   - Relatório do Quadro de Trabalho
 *   - Organograma
 *
 * Cada aba reaproveita a página existente SEM copiar lógica, garantindo
 * zero perda de funcionalidade e reduzindo a duplicação do sidebar.
 */
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Network, LayoutGrid, ClipboardList, GitBranch } from "lucide-react";
import SectorsPage from "./SectorsPage";
import WorkBoardsPage from "./WorkBoardsPage";
import WorkBoardReportPage from "./WorkBoardReportPage";
import OrgchartPage from "./OrgchartPage";

const VALID_TABS = ["setores", "quadros", "relatorio", "organograma"];

export default function SetoresEQuadroPage() {
  const [params, setParams] = useSearchParams();
  const current = VALID_TABS.includes(params.get("tab")) ? params.get("tab") : "setores";

  const setTab = (v) => {
    const next = new URLSearchParams(params);
    next.set("tab", v);
    setParams(next, { replace: true });
  };

  return (
    <div className="space-y-4" data-testid="setores-e-quadro-page">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#8A6B2B] font-medium">
            Gestão · Estrutura
          </div>
          <h1 className="font-display text-3xl font-semibold">Setores e Quadro</h1>
          <p className="mt-1 text-[13.5px] text-muted-foreground">
            Hub unificado: estrutura de setores, quadros operacionais por escala, relatório e organograma.
          </p>
        </div>
      </div>

      <Tabs value={current} onValueChange={setTab} className="w-full">
        <TabsList className="mb-2">
          <TabsTrigger value="setores" data-testid="tab-setores">
            <Network className="h-3.5 w-3.5 mr-1.5" /> Setores
          </TabsTrigger>
          <TabsTrigger value="quadros" data-testid="tab-quadros">
            <LayoutGrid className="h-3.5 w-3.5 mr-1.5" /> Quadros
          </TabsTrigger>
          <TabsTrigger value="relatorio" data-testid="tab-relatorio">
            <ClipboardList className="h-3.5 w-3.5 mr-1.5" /> Relatório
          </TabsTrigger>
          <TabsTrigger value="organograma" data-testid="tab-organograma">
            <GitBranch className="h-3.5 w-3.5 mr-1.5" /> Organograma
          </TabsTrigger>
        </TabsList>

        <TabsContent value="setores" className="m-0">
          <SectorsPage />
        </TabsContent>
        <TabsContent value="quadros" className="m-0">
          <WorkBoardsPage />
        </TabsContent>
        <TabsContent value="relatorio" className="m-0">
          <WorkBoardReportPage />
        </TabsContent>
        <TabsContent value="organograma" className="m-0">
          <OrgchartPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}
